document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("news-search-date-button");
  if (toggleButton) {
    const dateList = document.getElementById("news-search-date-list");
    const dateIcon = toggleButton.querySelector(".news-post__search-date-icon");
    toggleButton.addEventListener("click", function () {
      const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
      toggleButton.setAttribute("aria-expanded", !isExpanded);
      dateList.classList.toggle("news-post__search-date-list--show");
      dateIcon.classList.toggle("news-post__search-date-icon--open");
    });
  }
});
